export default "__VITE_ASSET__e1ae8af8__"